import { useState } from "react";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../components/ui/card";
import { Checkbox } from "../components/ui/checkbox";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSignInAction } from "@rhino-project/core/queries";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [status, setStatus] = useState("Sign In");
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = (location.state as { redirectTo?: string } | null)?.redirectTo ?? "/dual-use-on-ramp/my-submissions";
  const { mutate: signIn, isPending, error } = useSignInAction();

  const handleSignIn = () => {
    setStatus("Signing in...");
    signIn({ email, password } as any, {
      onSuccess: () => navigate(redirectTo),
      onError: () => setStatus("Sign In"),
    });
  };

  return (
    <div className="w-full min-w-0 bg-background text-foreground overflow-x-hidden">
      <div className="mx-auto flex w-full max-w-7xl min-w-0 flex-col gap-6 px-4 py-6 sm:px-6 lg:px-8">
        <section className="w-full">
          <div className="mx-auto grid w-full max-w-5xl gap-6 lg:grid-cols-2">
            <Card className="border-border shadow-sm">
              <CardHeader>
                <CardTitle>Sign In</CardTitle>
                <CardDescription>Access your dual-use, sponsor, or navigator workspace.</CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" name="email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="you@organization.ca" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="password">Password</Label>
                  <Input id="password" name="password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="••••••••" />
                </div>
                <div className="flex items-center gap-2">
                  <Checkbox id="remember" checked={remember} onCheckedChange={(checked) => setRemember(Boolean(checked))} />
                  <Label htmlFor="remember" className="text-sm text-muted-foreground">Remember me on this device</Label>
                </div>
              </CardContent>
              <CardFooter className="flex items-center justify-between gap-3">
                <Button onClick={handleSignIn} disabled={!email || !password || isPending}>{isPending ? "Signing in..." : status}</Button>
                <Button asChild variant="outline"><Link to="/register">Create account</Link></Button>
              </CardFooter>
              {error && <p className="px-6 pb-4 text-sm text-destructive">Sign in failed. Check your credentials and try again.</p>}
            </Card>

            <Card className="border-border bg-muted/40 shadow-sm">
              <CardHeader>
                <CardTitle>Need help?</CardTitle>
                <CardDescription>Use concierge support for onboarding, routing, and account access questions.</CardDescription>
              </CardHeader>
              <CardContent className="space-y-3 text-sm text-muted-foreground">
                <p>• New to The Third Door? Register and choose your role.</p>
                <p>• Returning users can continue from saved submissions and queues.</p>
                <p>• Export-sensitive content should only be uploaded in secure flows.</p>
                <p>• MVP preview/demo accounts are seeded for guided reviews; do not enter real production credentials or live user data.</p>

              </CardContent>
              <CardFooter>
                <Button asChild variant="secondary"><Link to="/contact">Contact support</Link></Button>
              </CardFooter>
              {error && <p className="px-6 pb-4 text-sm text-destructive">Sign in failed. Check your credentials and try again.</p>}
            </Card>
          </div>
        </section>
      </div>
    </div>
  );
}